const HideOnMobile = ({ Component }) => {
  if (window.innerWidth > 767) {
    return Component;
  }
  return null;
};

export default HideOnMobile;
